import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import Reveal from "@/components/Reveal";
import { FAQS } from "@/config/site";

export const Faq = () => (
  <section id="faq" className="relative scroll-mt-24 py-24 sm:py-32">
    <div className="container-nova">
      <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr]">
        <Reveal>
          <div className="lg:sticky lg:top-28">
            <p className="label-eyebrow mb-4">FAQ</p>
            <h2 className="font-heading text-3xl font-800 leading-tight tracking-tight text-white sm:text-5xl" style={{ fontWeight: 800 }}>
              Questions,<br />answered
            </h2>
            <p className="mt-4 max-w-sm text-white/60">
              Everything about Nova, Premium, privacy and support in one place.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-b border-white/10">
                <AccordionTrigger className="py-5 text-left font-heading text-base font-semibold text-white hover:no-underline data-[state=open]:text-nova-cyan" data-testid={`faq-trigger-${i}`}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-white/60" data-testid={`faq-content-${i}`}>
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Faq;
